import classNames from 'classnames'

import type { ReactElement } from 'react'

import BlockTitle from '~/components/Blocks/Title'
import BlockValue from '~/components/Blocks/Value'
import GridItemLayout from '~/components/GridItemLayout'
import { getNumberWithSpaces } from '~/utils/number'

import './styles.scss'

interface Props {
  isCurrentValue?: boolean
  title: string
  value?: number
}

const MAUValueBlock = ({ isCurrentValue, title, value }: Props): ReactElement => {
  const valueClasses = classNames('mau-value-block-component__value', { current: isCurrentValue })

  return (
    <GridItemLayout className="mau-value-block-component">
      <BlockTitle>{title}</BlockTitle>
      <BlockValue className={valueClasses}>{getNumberWithSpaces(`${value}`)}</BlockValue>
    </GridItemLayout>
  )
}

export default MAUValueBlock
